import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { RaciNavigationService } from '../../../../navigation/raci-navigation.service';
import { ActionStageEnum } from '../../../raci/models/enums/action-stage-enum';
import { RaciService } from '../../../raci/services/raci.service';

/**
 * Handles the close valuation event component
 */
@Component({
  selector: 'close-valuation-event',
  templateUrl: './close-valuation-event.component.html',
  styleUrls: ['./close-valuation-event.component.css']
})
export class CloseValuationEventComponent implements OnInit, OnDestroy {

  /**
   * The current task.
   */
  @Input() set currentTask(value: any) {
    this.selectedTask = value;
    this.getReports();
  }

  /**
 * The project ID.
 */
  @Input() projectId: any;

  /**
   * Indicates whether to show title info.
   */
  @Input() showTitleInfo = false;

  /**
   * Active portfolio id
   */
  @Input() portfolioId: number;

  /**
   * Event emitter for the selected close option.
   */
  @Output() selectedCloseOption: EventEmitter<number> = new EventEmitter(null);

  /**
   * Event emitter for the selected copy properties option.
   */
  @Output() selectedCopyPropertiesOption: EventEmitter<boolean> = new EventEmitter(null);

  /**
   * Event emitter for the selected copy fx table and currencies option.
   */
  @Output() selectedCopyFxTablesOption: EventEmitter<boolean> = new EventEmitter(null);

  /**
   * Event emitter for the new valuation name.
   */
  @Output() newValuationName: EventEmitter<string> = new EventEmitter(null);

  /**
   * Event emitter for the new valuation date.
   */
  @Output() newValuationDate: EventEmitter<any> = new EventEmitter(null);

  /**
   * Indicates if the close valuation event option is selected.
   */
  closeValuationEventSelected = false;

  /**
   * Indicates if the create new close valuation event option is selected.
   */
  closeValuationEventCreateNewSelected = false;

  /**
   * Indicates if the close valuation event project option is selected.
   */
  closeValuationEventProjectSelected = false;

  /**
   * The selected option.
   */
  optionSelected: any;

  /**
   * The dialog message.
   */
  dialogMessage: string;

  /**
   * Indicates if there are reports.
   */
  hasReports = false;

  /**
   * The selected task
   */
  selectedTask: any;
  /**
   * The valuation event ID.
   */
  valuationEventId: any;

  /**
   * The new valuation date.
   */
  valuationDate: any;

  /**
   * The new valuation event name.
   */
  valuationName: any;

  /**
   * Copy properties option for new valuation event.
   */
  copyProperties = false;

  /**
   * Copy fx table and currencies option for new valuation event.
   */
  copyFxTables = false;

  /**
   * The subscriptions
   */

  private _subscriptions: Array<Subscription> = new Array<Subscription>();

  /**
   * Constructor
   * @param _raciService RaciService
   * @param _raciNavigationService RaciNavigationService
   */
  constructor(private _raciService: RaciService,
    private _raciNavigationService: RaciNavigationService) { }

  /**
  * OnInit
  */
  ngOnInit(): void {
    this.getReports();
  }

  /**
 * On destroy
 */
  ngOnDestroy(): void {
    this._subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Retrieves valuation event reports
   */
  getReports() {
    this._subscriptions.push(this._raciService.getReports(this.selectedTask?.projectId, this.selectedTask?.portfolioId ?? this.selectedTask?.taskValuationPortfolioId).subscribe(data => {
      if (data.length > 0) {
        this.hasReports = true;
      }
    }));
  }

  /**
  * Action stage enum getter
  */
  get ActionStageEnum() {
    return ActionStageEnum;
  }

  /**
   * Hides close valuation event dialog
   * @param event Option click event
   */
  hideCloseValuationEventDialog(event: any) {
    this._raciNavigationService.showCloseValuationEventDialog(false);
  }

  /**
   * Selects the close valuation event option.
   */
  selectCloseValuationEventOption(event: any) {
    this._raciNavigationService.showCloseValuationEventDialog(false);
  }

  /**
   * continues the close valuation event option.
   */
  continue(option: number) {
    this.selectedCloseOption.emit(option);
    this.selectedCopyPropertiesOption.emit(this.copyProperties);
    this.selectedCopyFxTablesOption.emit(this.copyFxTables);
    this.newValuationName.emit(this.valuationName);
    this.newValuationDate.emit(this.valuationDate);
    this._raciNavigationService.showCloseValuationEventDialog(true);
  }
}
